'use client';

import React, { ReactNode, useEffect } from 'react';
import {
	FormContext_State,
	UpdateActiveStep,
	useFormContext,
} from '../FormContext';

export interface StepProps<Steps> {
	testId?: string;
	children: ReactNode;
	name: Steps;
	onNext?: UpdateActiveStep;
}

const Step = <Steps extends string, State, Action>(props: StepProps<Steps>) => {
	const { children, name, onNext } = props;
	const { registerStep, state } = useFormContext<Steps, State, Action>();

	useEffect(() => {
		registerStep(name, onNext);
	}, [registerStep, name, onNext]);

	// We have to cast the state as FormContext_State<Steps> because we can't
	// make the generic more restrictive then it adds a lot more code to each
	// implementation of the form context.
	if (name !== (state as FormContext_State<Steps>).activeStep) {
		return null;
	}

	return <>{children}</>;
};

export default Step;
